"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initErrorHandler = void 0;
const ERROR_CSS_CLASS = 'highlightError';
const ERRORS = [{
  message: 'The provided credentials are incorrect',
  fieldId: 'signInName'
}, {
  message: 'The provided credentials are incorrect',
  fieldId: 'password'
}, {
  message: 'Missing required element: Country',
  fieldId: 'combinedLocation'
}, {
  message: 'The password entry fields do not match',
  fieldId: 'newPassword'
}, {
  message: 'A user with the specified e-mail address already exists',
  fieldId: 'email'
}];
const mapErrorFieldByErrorMessage = errorMessage => {
  var _a;
  const errorField = ERRORS.filter(error => errorMessage.includes(error.message));
  return (_a = errorField[0]) === null || _a === void 0 ? void 0 : _a.fieldId;
};
const createPageErrorFieldMutationObserver = errorField => new MutationObserver(() => {
  ERRORS.forEach(error => {
    const field = document.getElementById(error.fieldId);
    if (field) {
      field.classList.remove(ERROR_CSS_CLASS);
    }
  });
  if (errorField.style.display !== 'none') {
    const errorFieldId = mapErrorFieldByErrorMessage(errorField.innerText);
    const newErrorField = document.getElementById(errorFieldId);
    if (errorFieldId && newErrorField) {
      newErrorField.classList.add(ERROR_CSS_CLASS);
    }
  }
});
const initErrorHandler = () => {
  document.querySelectorAll('.error.pageLevel').forEach(errorField => {
    createPageErrorFieldMutationObserver(errorField).observe(errorField, {
      attributes: true,
      childList: true
    });
  });
};
exports.initErrorHandler = initErrorHandler;
//# sourceMappingURL=errorHander.js.map